import { constructIds } from "../../config/common"
import { getFirstLetterOfEachWords } from "../../utils/commonUtils";


export const generateRRDefName = (transactionName, eventName) => {
    const hashedTransaction = getFirstLetterOfEachWords(transactionName)
    return `${eventName}_${hashedTransaction}`
}
export const findDelegateLinkedEvents = payload => {
  /**for handling edit */
  const selectedRrdefEvent = payload.selectedRrdefEvent ? payload.selectedRrdefEvent : null;

  const { id, dir, ttype, allEvents, rrdefs } = payload
  const rrdefEventIds = rrdefs.map(item => item.attributes?.tcmd).filter(item => item !== selectedRrdefEvent)

  let alphabeticallyArrangedList = []

  if (ttype && dir === 'OUT') {
    const events = allEvents.map(item => {
      if (item.src === ttype && item.dst === id) return { label: item.name, value: item._id, disabled: rrdefEventIds.includes(item.id) ? true : false };
    }).filter(i => i);

    alphabeticallyArrangedList = events.sort(function (a, b) {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    })
  }
  else if (ttype && dir === 'IN') {
    const events = allEvents.map(item => {
      if (item.dst === ttype && item.src === id) return { label: item.name, value: item._id, disabled: rrdefEventIds.includes(item.id) ? true : false };
    }).filter(i => i);
    alphabeticallyArrangedList = events.sort(function (a, b) {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    })
  }

  return alphabeticallyArrangedList

}

export const doesSameRrdefExist = (name, rrdefs, rrdefId) => {
  let status = true;
  if (rrdefId === undefined) {
    status = rrdefs.find(rrdef => {
      return rrdef.name == name
    });
  }
  else {
    status = rrdefs.find(rrdef => {
      return rrdef.name == name && rrdef._id != rrdefId
    });
  }
  return status == null ? true : false;
}


export const rrdefAutomation = ({ event, srcNode, dstNode, applicationName }) => {

  const delegate = srcNode.type === 1 ? srcNode : dstNode

  const rrdef = {
    name: event.name,
    // id: shortUuid.generate(),
    type: 13,
    attributes: {
      dir: srcNode.type === 1 ? 'IN' : 'OUT',
      ttype: srcNode.type === 1 ? dstNode._id : srcNode._id,
      tcmd: event.id,
      delegate: delegate._id,
      name: event.name
    }
  }

  if (['http_delegate', 'http2_delegate', 'diameter_delegate', 'radius_delegate'].includes(delegate.attributes.type)) {

    rrdef.attributes.commandtype = rrdef.attributes.dir === 'IN' ? 'req' : 'res'

  }

  if (['http_delegate', 'http2_delegate'].includes(delegate.attributes.type)) {

    if (rrdef.attributes.dir === 'IN') {

      rrdef.attributes.path = `/iot/${applicationName}/${event.name}/{instance}/`
      rrdef.attributes.tinstance = `{instance}`

    }

  }


  return rrdef

}


export const findDelegateLinkedNodes = payload => {
  const { id, events, clusterlets } = payload;
  const nodesLinkedToDelegate = events.map(event => {

    /**one node must be delegate and the other node must not be delegate */
    if (event.src == id && (constructIds.find(item => item.type === "external_function").id !== clusterlets.find(item => item._id == event.dst).type)) return event.dst;
    if (event.dst == id && (constructIds.find(item => item.type === "external_function").id !== clusterlets.find(item => item._id == event.src).type)) return event.src;
  })
  const nodes = Array.from(new Set(nodesLinkedToDelegate));
  let clusterletKeyValuePairs = []

  clusterlets.map(item => {
    if (nodes.includes(item._id)) clusterletKeyValuePairs.push({ value: item._id, label: item.name })
  })

  const alphabeticallyArrangedList = clusterletKeyValuePairs.sort(function (a, b) {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  })

  return alphabeticallyArrangedList
}